import { defineComponent } from '@digitalbranch/app'

import template from './ui-template.html'

export const uiTemplate = defineComponent({
  name: 'ui-template',
  template,
})
